import {Pie} from 'react-chartjs-2';
import React from 'react';
import Chart from 'chart.js/auto'; 
import './ChantierInfoGraph.css';

/**
 * graphique
 * @param {*} props props
 * @return {*} graph
 */
export default function ChantierInfoGraphView(props) {
  const data = {
    labels: props.names,
    datasets: [
      {
        data: props.sums,
        backgroundColor: props.colors,
        total: props.total, // add total property
      },
    ],
  };

  const dataEmploye = {
    labels: props.users,
    datasets: [
      {
        data: props.sumUser,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const hasHour = Math.floor(context.parsed / 60) === 0;
            const totalheure = hasHour ? '' : Math.floor(context.parsed / 60) + 'h';
            const TotalMinute = hasHour ? String(context.parsed % 60).padStart(2, '0') + 'min' : String(context.parsed % 60).padStart(2, '0');
            return (
              context.label +
              ': ' + totalheure+
                TotalMinute +
              ' (' +
              ((context.parsed / context.dataset.total) * 100).toFixed(2) +
              '%)'
            );
          },
          aspectRatio: 1, // set the aspect ratio
          maintainAspectRatio: false,
        },
      },
    },
  };

  const legendData = data.datasets[0].data ?
  data.datasets[0].data.map((value, index) => {
    const minutesTotal = data.datasets[0].data[index];
    const hours = Math.floor(minutesTotal / 60);
    const minutes = Math.round(minutesTotal % 60).toString().padStart(2, '0');

    return (
      <tr key={index}>
        <td>
          <span
            style={{
              display: 'inline-block',
              width: '20px',
              height: '20px',
              backgroundColor: data.datasets[0].backgroundColor[index],
              marginRight: '5px',
            }}
          ></span>
          {data.labels[index] }
        </td>
        <td> : {((value / data.datasets[0].total) * 100).toFixed(2)}% {hours === 0 ? minutes + 'min' : hours + 'h' + minutes}</td>
      </tr>
    );
  }) :
  null;


  const legendDataEmploye = dataEmploye.datasets[0].data ?
  dataEmploye.datasets[0].data.map((value, index) => {
    const minutesTotal = dataEmploye.datasets[0].data[index];
    const hours = Math.floor(minutesTotal / 60);
    const minutes = Math.round(minutesTotal % 60).toString().padStart(2, '0');

    return (
      <tr key={index}>
        <td>
          {dataEmploye.labels[index].name }
        </td>
        <td> : {hours === 0 ? minutes + 'min' : hours + 'h' + minutes}</td>
      </tr>
    );
  }) :
  null;


  return (
    <div>
      <div className="chantierinfograph-chart-container">
        <Pie data={data} options={options} />
      </div>
      <div className='chantierinfograph-textcenter'>
        <div >Total: {Math.floor(props.total / 60)}h{String(props.total % 60).padStart(2, '0')}</div>
      </div>
      <div style={{display: 'block'}}>
        <div className='chantierinfograph-textcenter'>
          <table >
            <tbody>{legendData}</tbody>
          </table>
        </div>
      </div>
      <div style={{display: 'block'}}>
        <div className='chantierinfograph-textcenter'>
          <table>
            <tbody>{legendDataEmploye}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

